<template>
  <div
    class="modal fade fixed-right modal-log modal-log-audit"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div role="document" class="modal-dialog modal-dialog-vertical">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ type | capitalise }} Log - {{ target.name }}</h5>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group mb-2">
            <label class="sr-only">Search</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <font-awesome :icon="['fal', 'search']" />
                </div>
              </div>
              <input v-model="params.search" type="text" placeholder="Search" class="form-control" />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group mb-0">
                <label>Date</label>
                <flatpickr
                  class="form-control date-range flatpickr-input"
                  name="date_range"
                  :config="dateConfig"
                  v-model="params.date"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group mb-0">
                <label>User</label>
                <input v-model="params.user" type="text" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <ul class="list-data no-links has-button log-list">
          <li class="data-heading d-none d-md-block sticky-top">
            <div class="row">
              <div class="col-md-2">Date</div>
              <div class="col-md-1">Time</div>
              <div class="col-md-4">User</div>
              <div class="col-md-4">Action</div>
            </div>
            <!-- /.row -->
          </li>

          <loading-spinner v-if="fetching"/>

          <no-results v-else-if="haveNoLogs">
            <li>No Logs found.</li>
          </no-results>

          <!-- log items -->
          <Item v-else :type="type" v-for="log of logs" :log="log" :key="log.id" />
        </ul>

        <lazy-loading
          :loading="$loading"
          :reached-bottom="handleGetNexCallback"
          scroll-target=".log-list"
          ref="lazy"
        >
          <loading-spinner slot="loading" />
          <span slot="finished" />
        </lazy-loading>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import Item from './Item'
import Flatpickr from 'vue-flatpickr-component'
import { logComputed, logMethods } from 'vx/helpers'
import { debounce } from 'lodash'

export default {
  components: {
    Item,
    Flatpickr
  },

  props: {
    type: {
      type: String,
      required: true
    },
    target: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    fetching: false,
    params: {}
  }),

  mounted () {
    this.getLogsWithParams = debounce(this.getLogsWithParams, 500)

    const $modal = $('.modal-log-audit')

    $modal.on('show.bs.modal', () => {
      if (this.$refs.lazy) {
        this.$refs.lazy.$emit('reset')
      }

      this.params = {}
    })
  },

  watch: {
    params: {
      immediate: true,
      deep: true,
      handler () {
        this.getLogsWithParams()
      }
    }
  },

  computed: {
    ...logComputed,

    haveNoLogs () {
      return this.logs.length === 0
    },

    dateConfig () {
      return {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Z',
        mode: 'range'
      }
    }
  },

  methods: {
    ...logMethods,

    async getLogsWithParams (next = false) {
      this.fetching = true

      this.getLogs({
        params: this.params, target: this.target, type: this.type, next
      }).finally(() => {
        this.fetching = false
      })
    },

    async handleGetNexCallback () {
      await this.getLogsWithParams(true)
    }
  }
}
</script>
